import Vue from 'vue'
import VueI18n from 'vue-i18n'

import { LANGUAGE } from './settings.js'

const messages = {}

if (LANGUAGE === 'en') {
  messages.en = {
    ieMessage: '<h2 class="mb-sm">Lieber Gast,</h2><p>Sie verwenden aktuell leider den veralteten Internet Explorer, der die Buchungsfunktion auf unserer Seite nicht mehr unterstützt.</p><p>Bitte verwenden Sie einen aktuellen Browser, wie z.B. Firefox, Chrome, Safari, Edge, Opera o.ä., dann funktioniert alles problemlos.</p><p>Ihr Miniatur Wunderland Team</p>',
    cartError: {
      expired: 'Your articles have been expired. Please select a new arrival time.',
      vouchers: 'Vouchers can only be purchased in combination with a ticket. Please select a time frame to continue.',
      tours: 'Please add at least {minimumExperiences} experiences to the shopping cart or select tickets without waiting time.',
      comboTickets: 'The combo-tickets are only bookable in combination with a ticket.',
      tooManyEvents: 'Maximum order quantity is 14 tickets. Please split your tickets in multiple orders.'
    }
  }
}

if (LANGUAGE === 'de') {
  messages.de = {
    ieMessage: '<h2 class="mb-sm">Lieber Gast,</h2><p>Sie verwenden aktuell leider den veralteten Internet Explorer, der die Buchungsfunktion auf unserer Seite nicht mehr unterstützt.</p><p>Bitte verwenden Sie einen aktuellen Browser, wie z.B. Firefox, Chrome, Safari, Edge, Opera o.ä., dann funktioniert alles problemlos.</p><p>Ihr Miniatur Wunderland Team</p>',
    cartError: {
      expired: 'Ihre Artikel sind abgelaufen. Bitte wählen Sie eine neue Ankunftszeit.',
      vouchers: 'Gutscheine können nur in Verbindung mit Eintrittskarten erworben werden. Bitte wählen Sie Ihre gewünschte Besuchszeit, um fortfahren zu können.',
      tours: 'Bitte fügen Sie mindestens {minimumExperiences} Erlebnisse zum Warenkorb hinzu oder wählen Tickets ohne Wartezeit.',
      comboTickets: 'Das Kombiticket ist nur in Verbindung mit einer Eintrittskarte für das Miniatur Wunderland buchbar.',
      tooManyEvents: 'Sie können maximal 14 Tickets auf einmal bestellen. Bitte teilen Sie die benötigte Anzahl auf mehrere Bestellungen auf.'
    }
  }
}

Vue.use(VueI18n)

export default new VueI18n({
  locale: LANGUAGE,
  fallbackLocale: LANGUAGE,
  messages
})
